import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { AttentionSound } from 'components/views/atoms/sounds/AttentionSound';
import { StandByFrame } from 'components/views/molecules/StandByFrame';
import { HeartbeatResult } from 'services/useStandBy';

const flashing = keyframes({
    from: {
        borderColor: 'red',
    },
    to: {
        borderColor: 'transparent',
    }
});

const AlertFrame = styled.div<{ alert: 'green' | 'red' }>(props => ({
    boxSizing: 'border-box',
    border: props.alert === 'green' ? 'solid thick transparent' : 'solid thick',
    animation: props.alert === 'green' ? undefined : `${flashing} 1s ease alternate infinite`,
    position: 'relative',
}));

const AlertTickerBox = styled.div({
    'position': 'absolute',
    'bottom': '100%',
    'border': 'solid thick transparent',
});

const Frame = styled.div({
    height: '100%',
    flexShrink: 0,
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
});

const StyledVehicleStatus = styled.div({
    flexGrow: 1,
    flexShrink: 2,
    padding: '10px',
});

const StyledSteeringIndicator = styled.div({
    flexGrow: 2,
    flexShrink: 1,
});

const StyledSpeedMeter = styled.div({
    flexGrow: 1,
    flexShrink: 0,
});

const StyledDriveInfo = styled.div({
    flexGrow: 2,
    flexShrink: 0,
    width: '30%',
    height: '100%',
    padding: '10px',
    boxSizing: 'border-box',
});

const StyledDriveSwitch = styled.div({
    flexGrow: 2,
    flexShrink: 0,
    width: '15%',
    height: '100%',
    padding: '10px',
    boxSizing: 'border-box',
});

export type ControllerPanelProps = {
    vehicleStatus?: JSX.Element;
    steeringIndicator: JSX.Element;
    speedMeter: JSX.Element;
    driveInfo: JSX.Element;
    driveSwitch: JSX.Element;
    alertTicker?: JSX.Element;
    alerting?: 'green' | 'red';
    standby?: boolean;
    onStandBy?: () => void;
    heartbeatStatus?: HeartbeatResult;
    isStandByAllowed?: boolean;
}

export function ControllerPanel(props: ControllerPanelProps) {
    const { vehicleStatus, steeringIndicator, speedMeter, driveInfo, driveSwitch } = props;
    const { alerting = 'green', alertTicker } = props;
    const { standby = false, onStandBy, heartbeatStatus, isStandByAllowed } = props;

    return (
        <AlertFrame alert={alerting}>
            {
                alerting != 'green'
                    ? <AttentionSound />
                    : <></>
            }
            {alertTicker && alerting != 'green'
                ? <AlertTickerBox>{alertTicker}</AlertTickerBox>
                : <></>
            }
            <StandByFrame standby={standby} onClick={onStandBy} heartbeatStatus={heartbeatStatus} isStandByAllowed={isStandByAllowed}>
                <Frame >
                    {vehicleStatus ? <StyledVehicleStatus>{vehicleStatus}</StyledVehicleStatus> : <React.Fragment />}
                    <StyledSteeringIndicator>{steeringIndicator}</StyledSteeringIndicator>
                    <StyledSpeedMeter>{speedMeter}</StyledSpeedMeter>
                    <StyledDriveInfo>{driveInfo}</StyledDriveInfo>
                    <StyledDriveSwitch>{driveSwitch}</StyledDriveSwitch>
                </Frame>
            </StandByFrame>
        </AlertFrame>
    );
}
